import React from 'react';
import styled, { keyframes } from 'styled-components';
import { prop } from 'styled-tools';

/*
 * Styles
 */

const TextIn = keyframes`
  0% {
    opacity: 0;
  }
`;

const Text = styled.text`
  animation: ${TextIn} 1800ms 600ms ${prop('theme.settings.easings.quintOut')} 1 backwards};
  dominant-baseline: middle;
  fill: ${prop('theme.colors.gray')};
  font-size: ${prop('theme.scale.down2')};
  text-anchor: middle;
  text-transform: uppercase;
  &:nth-of-type(3n + 1) {
    animation-delay: 600ms;
  }
  &:nth-of-type(3n + 2) {
    animation-delay: 750ms;
  }
  &:nth-of-type(3n + 3) {
    animation-delay: 900ms;
  }
`;

/*
 * Component
 */

const HaloAxesLabels = (props) => {
  const { arcAngleCentroid, count, pieSize, radius } = props;

  return (
    [...Array(count).keys()].map((n) => {
      return(
        <Text
          key={n}
          x={((radius - pieSize) * 1.05) * Math.cos(arcAngleCentroid(n) - Math.PI * 0.5)}
          y={((radius - pieSize) * 1.05) * Math.sin(arcAngleCentroid(n) - Math.PI * 0.5)}
        >
          {n + 1}
        </Text>
      )
    })
  )
};

export default HaloAxesLabels;
